import { css } from 'emotion';

import { colors } from '../styles';

export const divider = (vertical?: boolean) => css`
  border: none;
  display: block;
  height: ${vertical ? '100%' : '1px'};
  min-height: ${vertical ? '0' : '1px'};
  width: ${vertical ? '1px' : '100%'};
  min-width: ${vertical ? '1px' : '0'};
  margin: ${vertical ? 'inherit' : '0'};
  background-color: ${colors.gray.light};
`;
